export const orderActionTypes = {
	GET_ALL_ORDERS: "GET_ALL_ORDERS",
	GET_SINGLE_ORDER: "GET_SINGLE_ORDER",
	GET_ORDER_STATS: "GET_ORDER_STATS",
	GET_CUSTOMER_ORDERS: "GET_CUSTOMER_ORDERS",
};
